import { render, staticRenderFns } from "./playText.vue?vue&type=template&id=166dfa24&scoped=true"
import script from "./playText.vue?vue&type=script&lang=js"
export * from "./playText.vue?vue&type=script&lang=js"
import style0 from "./playText.vue?vue&type=style&index=0&id=166dfa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166dfa24",
  null
  
)

export default component.exports